import { useEffect } from "react";

function SizeSelectBox({
  localLoading,
  Skeleton,
  productDetails,
  selectedSize,
  unit,
  setUnit,
  setSelectedSize,
  sizeSelection,
}) {

  useEffect(() => {
    if (productDetails?.product_sizes?.length > 0) {
      setUnit("cm"); // default CM
      setSelectedSize(productDetails.product_sizes[0]);
      sizeSelection(productDetails.product_sizes[0]);
    }
  }, [productDetails?.id]);

  if (localLoading) {
    return (
      <div className="size-selector">
        <p><Skeleton width={150} /></p>
        <div style={{ display: "flex", gap: 10 }}>
          {Array(3).fill(0).map((_, i) => (
            <Skeleton key={i} width={60} height={60} />
          ))}
        </div>
      </div>
    );
  }

  if (!productDetails?.product_sizes?.length) return null;
  return (

    <div className="size-selector">
      {localLoading ? (
        <>
          <p>
            <Skeleton width={150} />
          </p>
          <div style={{ display: "flex", gap: 10 }}>
            {Array(3)
              .fill(0)
              .map((_, i) => (
                <Skeleton key={i} width={60} height={60} />
              ))}
          </div>
        </>
      ) : productDetails?.product_sizes?.length > 0 && selectedSize.size !== "NA" ? (
        <>
          {productDetails?.category_action_url === "dustbins" ? (
            <p className="selected-size-label">
              Choose Capacity:&nbsp;
              {selectedSize && <strong>{selectedSize.capacity}</strong>}
            </p>
          ) : productDetails?.category_action_url === "floor-covering" ? (
            <p className="selected-size-label">
              Select Size :&nbsp;
              {selectedSize && (
                <strong>
                  {unit === "cm"
                    ? selectedSize.size
                    : unit === "ft"
                      ? selectedSize.size_in_feet
                      : ""}
                </strong>
              )}
            </p>
          ) : (
            <p className="selected-size-label">
              Choose Size :&nbsp;
              {selectedSize && <strong>{selectedSize.size}</strong>}
            </p>
          )}
          {productDetails?.category_action_url === "floor-covering" ? (
            <div className="unit-toggle">
              <button
                className={unit === "cm" ? "active" : ""}
                onClick={() => setUnit("cm")}
              >
                Cm
              </button>

              <button
                className={unit === "ft" ? "active" : ""}
                onClick={() => setUnit("ft")}
              >
                Feet
              </button>
            </div>
          ) : (
            <></>
          )}
          <div className="size-options">
            {productDetails.product_sizes.map((size) => (
              <div
                key={size.id}
                className={`size-btn ${selectedSize?.id === size.id ? "active-size" : ""
                  }`}
                onClick={() => {
                  setSelectedSize(size);
                  sizeSelection(size);
                  // setQuantity(1);
                }}
              >
                <div className="set_btn_trcak">
                  {size?.size_vector_media ? (
                    <img
                      src={size?.size_vector_media}
                      className="size-image"
                      alt={size.size}
                      loading="lazy"
                    />
                  ) : (
                    <></>
                  )}
                </div>
                {productDetails?.category_action_url === "dustbins" ? (
                  <div className="lbl-track">{size.capacity}</div>
                ) : productDetails?.category_action_url === "floor-covering" ? (
                  selectedSize && (
                    <div className="lbl-track">
                      {unit === "cm"
                        ? size.size
                        : unit === "ft"
                          ? size.size_in_feet
                          : ""}
                    </div>
                  )
                ) : (
                  <div className="lbl-track">{size.size}</div>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        // <Skeleton count={2} />
        <></>
      )}
    </div>
  )
}
export default SizeSelectBox;